import { doGet, doPatch, doPost } from 'circe/Http/saga';
import { operatorClient, shippingClient } from 'domain/HttpClients';

export const fetch = (filters) => operatorClient
  .Get('/api/shipments')
  .withParams({ ...filters, domain: SYSTEM_DOMAIN })
  .send();

export const cancel = (shipmentId, headers) => doPost(
  `${SHIPPING_EDGE}/api/shipments/${shipmentId}/cancelRequest`,
  {},
  headers,
  {},
  null,
  false,
  true,
);
export const cancelConfirm = (invoiceId, shipmentId, headers) => doPost(
  `${SHIPPING_EDGE}/api/shipments/${shipmentId}/cancelConfirm`,
  {},
  headers,
  {
    params: {
      invoice: invoiceId,
    },
  },
  null,
  false,
  true,
);

export const updateRecipient = (payload, headers) => doPost(
  '/api/masheed/escalated-sales-order/assign-shipments',
  payload,
  headers,
  {},
  OPERATIONS_EDGE,
  false,
  true,
);
